module.exports = __webpack_public_path__ + "chengping01.jpg?c2e16b6449f579d014e4b4eaf111253b";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/chengping01.jpg
// module id = 105
// module chunks = 0